import { OriginApp } from '../types';
const WIDGET_THEMES = ['default', 'studio', 'odeditor', 'odeditor-dark', 'wixel'];

// A declared theme is untrusted input: hosts pass it into init(), and the widget
// reads it back off an iframe query param.
export const isWidgetTheme = value => typeof value === 'string' && WIDGET_THEMES.includes(value);

// Theme implied by the host surface, for hosts that declare no `theme`.
export const originToTheme = originApp => {
  if (originApp === OriginApp.Studio2Editor) {
    return 'odeditor-dark';
  }
  if (originApp === OriginApp.StudioEditor || originApp === OriginApp.Blocks) {
    return 'studio';
  }
  if (originApp === OriginApp.Editor3) {
    return 'odeditor';
  }
  return 'default';
};

/**
 * The one place origin turns into a theme: a theme the host declared wins,
 * otherwise fall back to the one its origin implies.
 *
 * Resolve once — the widget shell does it when init params land, the widget app
 * when it boots — so everything downstream takes the resolved `WidgetTheme` and
 * never re-derives it from the origin.
 */
export const getWidgetTheme = (originApp, theme) => isWidgetTheme(theme) ? theme : originToTheme(originApp);
//# sourceMappingURL=index.js.map